(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["job-board"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncJobApplicationSubject(form) {
      if (!form) {
        return;
      }
      var select = form.querySelector('[data-job-title-select]');
      var subject = form.querySelector('input[name="_subject"]');
      if (!select || !subject) {
        return;
      }
      var prefix = (form.getAttribute('data-subject-prefix') || '').trim();
      var title = (select.value || '').trim();
      subject.value = prefix ? prefix + ' ' + title : title;
    }

    document.querySelectorAll('.job-board__apply-form').forEach(function (form) {
      var select = form.querySelector('[data-job-title-select]');
      if (select) {
        select.addEventListener('change', function () {
          syncJobApplicationSubject(form);
        });
        syncJobApplicationSubject(form);
      }
    });

    document.querySelectorAll('.job-board').forEach(function (board) {
      board.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-job-open-dialog]');
        if (openBtn) {
          var id = openBtn.getAttribute('aria-controls');
          var dlg = id && document.getElementById(id);
          if (dlg && typeof dlg.showModal === 'function') {
            dlg.showModal();
            var f = dlg.querySelector('.job-board__apply-form');
            syncJobApplicationSubject(f);
            var embed = dlg.querySelector('[data-reamaze-embed="contact"]');
            if (embed && !embed.querySelector('iframe') && window.Reamaze && typeof window.Reamaze.reload === 'function') {
              window.Reamaze.reload();
            }
          }
        }
        var closeBtn = e.target.closest('[data-job-close-dialog]');
        if (closeBtn) {
          var dialog = closeBtn.closest('dialog');
          if (dialog) {
            dialog.close();
          }
        }
      });
      board.querySelectorAll('dialog.job-board__dialog').forEach(function (dialog) {
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) {
            dialog.close();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
